/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import Router from 'vue-router'
import axios from './axios.js'
Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue')
              },
              {
                path: '/proveedores',
                name: 'proveedores',
                component: () => import('./views/Proveedores/wizard.vue')
              },
              {
                path: '/proveedores_lista',
                name: 'lista_proveedores',
                component: () => import('./views/Proveedores/table.vue')
              },
      

              {
                path: '/proyectos',
                name: 'proyectos',
                component: () => import('./views/Proyectos/wizard.vue')
              },
              {
                path: '/proyectos_lista',
                name: 'lista_proyectos',
                component: () => import('./views/Proyectos/lista.vue')
              },
              {
                path: '/lista_productos',
                name: 'lista_productos',
                component: () => import('./views/Productos/lista_productos.vue')
              },
              {
                path: '/certificaciones',
                name: 'certificaciones',
                component: () => import('./views/Certificaciones.vue')
              },
              {
                path: '/tienda',
                name: 'tienda',
                component: () => import('./views/Rewards/Tienda.vue')
              },
              {
                path: '/tienda_pedidos',
                name: 'Pedidos',
                component: () => import('./views/Rewards/Pedidos.vue')
              },
              {
                path: '/tutoriales',
                name: 'tutoriales',
                component: () => import('./views/Tutoriales.vue')
              },
              {
                path: '/perfil',
                name: 'perfil',
                component: () => import('./views/Perfil/perfil.vue')
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/login/Login.vue'),
                meta: {
                  notAuthRequired: true
                }
              },
              {
                path: '/pages/register',
                name: 'page-register',
                component: () => import('@/views/pages/register/Register.vue'),
                meta: {
                  rule: 'editor',
                  notAuthRequired: true
                }
              },        
              {
                path: '/pages/forgot-password',
                name: 'page-forgot-password',
                component: () => import('@/views/pages/ForgotPassword.vue'),
                meta: {
                  rule: 'editor',
                  notAuthRequired: true
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue'),
                meta: {
                  notAuthRequired: true
                }
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404',
              meta: {
                notAuthRequired: true
              }
        }
    ],
})
router.beforeEach(async (to, from, next) => {

    if (!to.meta.notAuthRequired) {
      axios.post('App','checkLogin',{},(data)=>{
          if(!data) {
            router.push({ path: '/pages/login'});
            return;
          }
      });
    }
    
    return next()

})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})
export default router